export const MENU_ITEM_CONTEXT_SWITCH_TYPOGRAPHY = {
  fontSize: { xs: "12px", sm: "13px" },
  fontWeight: 500,
  color: "text.secondary",
};

export const AVATAR_CONFIG = {
  width: "40px",
  height: "40px",
  fontSize: "20px",
  fontWeight: 400,
} as const;